import { useMemo } from 'react'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useScript } from '@bluheadless/ui-logic/src/hooks/use-script/useScript'
import { number } from 'prop-types'
import { Root } from './placement.styled'

const Placement = ({ purchaseAmount }) => {
	const {
		defaultCurrency,
		sales: {
			payments: {
				paypal: { enabled, clientId, scriptUrl },
			},
		},
	} = useConfig()

	const src = useMemo(() => {
		const srcUrl = new URL(scriptUrl)
		srcUrl.search = new URLSearchParams({
			'client-id': clientId,
			components: 'messages',
		}).toString()

		return srcUrl
	}, [clientId, scriptUrl])

	const status = useScript({
		src: enabled ? src : null,
	})

	return status === 'ready' ? (
		<Root>
			<div data-pp-message="" data-pp-amount={purchaseAmount} data-pp-currency={defaultCurrency} />
		</Root>
	) : null
}

Placement.propTypes = {
	purchaseAmount: number,
}

export default Placement
